<template>
    <div class="bar">
        <span class="value" :style="{ left: `${value}%` }">{{ meas.value }}</span>
        <div class="dote" :style="{ left: `${value}%` }"></div>
        <div class="progress">
            <div class="progress-bar" v-if="showLeftSide" :style="{width: '10%', backgroundColor: statusColors['RED']}"></div>
            <div class="progress-bar" v-if="showLeftSide" :style="{width: '12%', backgroundColor: statusColors['YELLOW']}"></div>
            <div class="progress-bar" :style="{width: showLeftSide ? '56%' : '78%', backgroundColor: statusColors['GREEN']}"></div>
            <div class="progress-bar" :style="{width: '12%', backgroundColor: statusColors['YELLOW']}"></div>
            <div class="progress-bar" :style="{width: '10%', backgroundColor: statusColors['RED']}"></div>
        </div>
        <div class="d-flex">
            <span class="bar-label" :class="{'text-left':!showLeftSide}" :style="{width: '22%'}">
                <span>
                    {{ meas.cfg.intRanges ? meas.cfg.intRanges['GREEN_MIN'] : meas.cfg.floatRanges['GREEN_MIN'] }}
                </span>
            </span>
            <span class="bar-label" :style="{width: '56%'}">
                <span>
                    {{ meas.cfg.intRanges ? meas.cfg.intRanges['GREEN_MAX'] : meas.cfg.floatRanges['GREEN_MAX'] }}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: ['meas', 'statusColors'],
    computed: {
        value () {
            const ranges = this.meas.cfg.intRanges || this.meas.cfg.floatRanges
            const barRanges = [[10, 0], [12, 10], [56, 22], [12, 78], [10, 90]]
            const customRanges = [
                [ranges['RED_MIN'], ranges['YELLOW_MIN']],
                [ranges['YELLOW_MIN'], ranges['GREEN_MIN']],
                [ranges['GREEN_MIN'], ranges['GREEN_MAX']],
                [ranges['GREEN_MAX'], ranges['YELLOW_MAX']],
                [ranges['YELLOW_MAX'], ranges['RED_MAX']]
            ]
            for (const index in customRanges) {
                const range = customRanges[index]
                if (this.meas.value >= range[0] && this.meas.value <= range[1]) {
                    return ((100 * this.meas.value / range[1]) / 100) * barRanges[index][0] + barRanges[index][1]
                }
            }
            return 100
        },
        showLeftSide () {
            return (this.meas.cfg.intRanges ? this.meas.cfg.intRanges['GREEN_MIN'] : this.meas.cfg.floatRanges['GREEN_MIN']) > 0
        }
    }
}
</script>

<style scoped>

    .progress {
        height: 7px;
    }

    .bar {
        width: 94.9%;
    }

    .bar-label {
        display: inline-block;
        width: 30px;
        color: #96A7AF;
        font-size: 12px;
        font-weight: 600;
        text-align: right;
    }

    .bar-label > span {
        display: inline-block;
        transform: translateX(50%);
    }

    .dote {
        width: 3px;
        height: 14px;
        background-color: #7B8C9F;
        position: relative;
        top: 10px;
        border-radius: 1.5px;
    }

    .value {
        font-size: 12px;
        position: relative;
        top: 10px;
        display: inline-block;
        transform: translateX(-50%);
    }

    @media (max-width: 768px) {
        .progress {
            height: 4px;
        }
    }
</style>
